var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 5,
    viewBox: "0 0 41 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.427734,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#C2C7D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerHandle);
export default __webpack_public_path__ + "static/media/drawer_handle.a1ff9de3b0f90e34a262dc55d6c02d0d.svg";
export { ForwardRef as ReactComponent };